import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Button.css";

/**
 * Reusable animated button.
 * Renders a <Link> when `to` is provided, otherwise a <button>.
 * variant: "primary" (solid yellow) | "secondary" (outlined)
 */
export default function Button({
  children,
  to,
  onClick,
  variant = "primary",
  type = "button",
  icon: Icon,
}) {
  const content = (
    <motion.span
      className={`btn btn--${variant}`}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 20 }}
    >
      <span className="btn__label">{children}</span>
      {Icon && <Icon className="btn__icon" aria-hidden="true" />}
      <span className="btn__ripple" aria-hidden="true" />
    </motion.span>
  );

  if (to) {
    return (
      <Link to={to} className="btn-link">
        {content}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className="btn-link">
      {content}
    </button>
  );
}
